import SyncableModel from "../../database/SyncableModel"
import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { Treatment } from "../../database"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"
import { withBaseModel } from "../extensions/with-base-model"
import { BaseModelStoreProps } from "../base-model-store/base-model-store"
import JalaAnalytic from "../../utils/jala-analytic"

const TreatmentStoreProps = {
  ...BaseModelStoreProps
}

/**
 * Model description here for TypeScript hints.
 */
export const TreatmentStoreModel = types
  .model("TreatmentStore")
  .props(TreatmentStoreProps)
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withBaseModel)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof TreatmentStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    init() {
      self.initModel();
    },
    async store(data) {
      if (self.rootStore.appStore?.isOffline)
        return this.storeOffline(data)
      return self.storeModel(Treatment, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Treatment added', data);
          return success;
        });
    },
    async storeOffline(data) {
      return self.storeModelOffline(Treatment, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Treatment added', data);
          return success;
        });
    },
    async update(model: SyncableModel, data) {
      if (self.rootStore.appStore?.isOffline)
        return this.updateOffline(model, data)
      return self.updateModel(Treatment, model, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Treatment edited', data);
          return success;
        });
    },
    async updateOffline(model: SyncableModel, data) {
      return self.updateModelOffline(Treatment, model, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Treatment edited', data);
          return success;
        });
    },
    async delete(model: SyncableModel) {
      if (self.rootStore.appStore?.isOffline)
        return this.deleteOffline(model)
      return self.deleteModel(Treatment, model)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Treatment deleted', model.toArray());
          return success;
        });
    },
    async deleteOffline(model: SyncableModel) {
      return self.deleteModelOffline(Treatment, model)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Treatment deleted', model.toArray());
          return success;
        });
    }
  }))

type TreatmentStoreType = Instance<typeof TreatmentStoreModel>
export interface TreatmentStore extends TreatmentStoreType {}
type TreatmentStoreSnapshotType = SnapshotOut<typeof TreatmentStoreModel>
export interface TreatmentStoreSnapshot extends TreatmentStoreSnapshotType {}
export const createTreatmentStoreDefaultModel = () => types.optional(TreatmentStoreModel, {})
